import { useContent } from "../../context/ContentContext";
import { assetUrl } from "../../lib/api";

const DEFAULTS = {
  cornerTag: "IFGL — MMXXVI",
  rightTag: "The Audition",
  markUrl: "/assets/ifgl-mark.png",
  logotype: "IFGL",
  tagline: "Indian Fashion Glamour League — 2026",
  warLine: "The war chose you.",
  ctaLabel: "Take Your Place",
  ctaHref: "#identify",
  scrollLabel: "Scroll",
};

const Hero = () => {
  const { content } = useContent();
  const h = { ...DEFAULTS, ...(content?.hero || {}) };

  return (
    <section
      data-testid="hero"
      className="relative min-h-screen w-full flex flex-col items-center justify-center px-6 bg-black overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-0 left-0 w-24 h-px bg-gold/30" />
        <div className="absolute top-0 left-0 w-px h-24 bg-gold/30" />
        <div className="absolute top-0 right-0 w-24 h-px bg-gold/30" />
        <div className="absolute top-0 right-0 w-px h-24 bg-gold/30" />
        <div className="absolute bottom-0 left-0 w-24 h-px bg-gold/30" />
        <div className="absolute bottom-0 left-0 w-px h-24 bg-gold/30" />
        <div className="absolute bottom-0 right-0 w-24 h-px bg-gold/30" />
        <div className="absolute bottom-0 right-0 w-px h-24 bg-gold/30" />
      </div>

      <div className="absolute top-8 left-0 right-0 flex items-center justify-between px-8 md:px-12">
        <span
          data-testid="hero-corner-tag"
          className="text-[10px] tracking-[0.4em] uppercase text-cotton/40 font-condensed font-light"
        >
          {h.cornerTag}
        </span>
        {h.rightTag && (
          <span className="hidden md:inline text-[10px] tracking-[0.4em] uppercase text-cotton/40 font-condensed font-light">
            {h.rightTag}
          </span>
        )}
      </div>

      {h.markUrl && (
        <div className="phoenix-glow anim-fade-up">
          <img
            src={assetUrl(h.markUrl)}
            alt="IFGL phoenix mark"
            data-testid="hero-mark"
            className="w-[180px] sm:w-[220px] md:w-[280px] lg:w-[320px] h-auto mb-2 select-none anim-float"
            draggable="false"
          />
        </div>
      )}

      <h1
        data-testid="hero-logotype"
        className="anim-fade-up delay-300 text-cotton text-center font-condensed font-black tracking-[0.18em] leading-none"
        style={{ fontSize: "clamp(72px, 18vw, 260px)", fontWeight: 900 }}
      >
        {h.logotype}
      </h1>

      <div
        data-testid="hero-rule"
        className="anim-fade-up delay-600 mt-6 flex items-center gap-3"
      >
        <span className="block w-2 h-2 border border-gold rotate-45" />
        <span className="block h-px w-20 bg-gold" />
        <span className="block w-2 h-2 border border-gold rotate-45" />
      </div>

      <p
        data-testid="hero-tagline"
        className="anim-fade-up delay-900 mt-6 text-[11px] md:text-xs tracking-[0.45em] uppercase text-cotton/70 font-light text-center"
      >
        {h.tagline}
      </p>

      <p
        data-testid="hero-warline"
        className="anim-fade-in delay-1500 mt-14 text-red text-2xl md:text-4xl font-condensed font-light tracking-[0.06em] uppercase text-center"
      >
        {h.warLine}
        <span className="caret-blink" />
      </p>

      <a
        href={h.ctaHref || "#identify"}
        data-testid="hero-cta"
        className="group anim-fade-up delay-2200 mt-12 relative inline-flex items-center gap-4 px-12 py-5 border border-red text-red text-sm md:text-base tracking-[0.4em] uppercase font-condensed font-semibold overflow-hidden transition-colors duration-500 hover:text-cotton"
      >
        <span className="relative z-10">{h.ctaLabel}</span>
        <span className="relative z-10 transition-transform duration-500 group-hover:translate-x-1">→</span>
        <span className="absolute inset-0 bg-red -translate-x-full group-hover:translate-x-0 transition-transform duration-500" />
      </a>

      <a
        href="#manifesto"
        data-testid="hero-scroll"
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-cotton/30 hover:text-red transition-colors"
        aria-label="Scroll"
      >
        <span className="text-[9px] tracking-[0.45em] uppercase">{h.scrollLabel}</span>
        <span className="relative block w-px h-10 bg-cotton/15 overflow-hidden">
          <span className="absolute inset-x-0 top-0 h-3 bg-red scroll-tick" />
        </span>
      </a>
    </section>
  );
};

export default Hero;
